export default {
      id: "icon-timetable-usage",
      viewBox: "0 0 28 30",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-timetable",
      toString: function () {
        return this.url;
      }
    }